// extracted by mini-css-extract-plugin
export default {"backlink":"TranscriptionParts_backlink__zXRqn"};